export { default as is3SFeatureEnabled } from './is3SFeatureEnabled';
